<template>
<div id="chartbox">
  <div id="controls" class="float-right noprint">
    
    <div class="hide" v-show="false">
      <label class="manpower-color"><input id="cmanpower" checked="checked" type="checkbox" label="Manpower Count" /> Manpower Count</label><br/>
      <label class="lostdays-color"><input id="clostdays" checked="checked" type="checkbox" label="Lost Production" /> Lost Production</label><br/>
      <label class="temp-low-color"><input id="ctemp-low" checked="checked" type="checkbox" label="Temp Low" /> Temp Low</label><br/>
      <label class="temp-high-color"><input id="ctemp-high" checked="checked" type="checkbox" label="Temp High" /> Temp High</label><br/>
      <label class="ice-color"><input id="cice" checked="checked" type="checkbox" label="Ice " /> Ice</label><br/>
      <label class="rain-color"><input id="crain" checked="checked" type="checkbox" label="Rain " /> Rain</label><br/>
      <label class="snow-color"><input id="csnow" checked="checked" type="checkbox" label="Snow " /> Snow</label><br/>
      <label class="sun-color"><input id="csun" checked="checked" type="checkbox" label="Sun " /> Sun</label><br/>
      <label class="wind-color"><input id="cwind" checked="checked" type="checkbox" label="Wind " /> Wind</label><br/>
    </div>

    <div style=""><datepicker v-model="this.startd" :format="yyyyMMdd" placeholder="Start Day" :enableTimePicker="false" autoApply class="mt-2" label="Report Start" /></div>
    <div style=""><datepicker v-model="this.endd" :format="yyyyMMdd" placeholder="End Day" :enableTimePicker="false" autoApply class="mt-2" label="Report End" /></div>
    <button class="btn-indigo m-2 ml-auto" @click="this.gochart(this.startd,this.endd);">Build Report</button>
  </div>
  <canvas id="myChart"></canvas>
</div>
</template>
<style>
#chartbox { max-width:100%; }
.manpower-color { accent-color:#f0a44e8e; color:#f0a44e8e; font-weight:bold; margin:10px; font-size:15px; }
.lostdays-color { accent-color:#e54e07; color:#e54e07; font-weight:bold; margin:10px; font-size:15px; }
.temp-low-color { accent-color:#4555CC; color:#4555CC; font-weight:bold; margin:10px; font-size:15px; }
.temp-high-color { accent-color:#e79519; color:#e79519; font-weight:bold; margin:10px; font-size:15px; }
.ice-color { accent-color:#d90eb4; color:#d90eb4; font-weight:bold; margin:10px; font-size:15px; }
.rain-color { accent-color:#3e8eff; color:#3e8eff; font-weight:bold; margin:10px; font-size:15px; }
.snow-color { accent-color:#9a2dff; color:#9a2dff; font-weight:bold; margin:10px; font-size:15px; }
.sun-color { accent-color:#c4bd00; color:#c4bd00; font-weight:bold; margin:10px; font-size:15px; }
.wind-color { accent-color:#0bb0a2; color:#0bb0a2; font-weight:bold; margin:10px; font-size:15px; }
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import moment from 'moment';
import Chart from 'chart.js/auto';
import Datepicker from '@vuepic/vue-datepicker';
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  components: {
    Chart,
    Datepicker,
  },
  props: {
    jobsites: Object,
    purchaseorders: Object,
    orders: Object,
    daylogs: Object,
    auth: Object,
  },
  mounted() {
    //this.gochart();
  },
  data() {
    return {
      moment: moment,
      Chart: Chart,
      startd: moment().subtract(30, 'days').format('YYYYMMDD'),
      endd: moment().format('YYYYMMDD'),
      curruentchart: null,
    }
  },
  methods: {
    checkdates(evt) {
      //console.log(evt);
    },
    gochart(startd,endd) {
      var startd = moment(startd).format('YYYYMMDD');
      var endd = moment(endd).format('YYYYMMDD');
      // JS - Destroy exiting Chart Instance to reuse <canvas> element
      let chartStatus = Chart.getChart("myChart"); // <canvas> id
      if (chartStatus != undefined) {
        chartStatus.destroy();
      }
      //-- End of chart destroy  


      var manpowerdata = [];
      var lowtemps = [];
      var hightemps = [];
      var clabels = [];
      var clabelsformat = [];
      var cdata = [];
      var lostdays = [];
      var ice = [];
      var rain = [];
      var snow = [];
      var sun = [];
      var wind = [];
      
      var daycount = startd;
      while (daycount <= endd) {
        clabelsformat.push(moment(daycount,'YYYYMMDD').format('MMM DD \'YY'));
        clabels.push(moment(daycount,'YYYYMMDD').format('YYYYMMDD'));
        daycount = moment(daycount, 'YYYYMMDD').add(1,'day').format('YYYYMMDD');
      }

      this.daylogs.data.forEach(function(v,k) {
        var reportday = parseInt(v.reportday);
        clabels.forEach(function(v2,k2) {
          if (reportday == parseInt(v2)) {
            lowtemps[k2] = v.temp_low;
            hightemps[k2] = v.temp_high;
            lostdays[k2] = (v.lostday ? 1 : 0);
            ice[k2] = (v.ice ? 1 : 0);
            rain[k2] = (v.rain ? 1 : 0);
            snow[k2] = (v.snow ? 1 : 0);
            sun[k2] = (v.sun ? 1 : 0);
            wind[k2] = (v.wind ? 1 : 0);

            try{
              var worksummary = JSON.parse(v.workersummary);
              manpowerdata[k2] = 0;
              //console.log(v.temp_low);
              for (const [key, value] of Object.entries(worksummary)) {
                manpowerdata[k2] += parseInt(value.manpower);
              }
            } catch(e) { /* console.warn(e); */ }
          }
        });
      });

      const ctx = document.getElementById('myChart');

      var manpowerDataSet = {
            label: 'Manpower',
            data: manpowerdata,
            borderWidth: 1,
            backgroundColor: '#f0a44e5a',
            stack: 'manpower',
          };
      var lostdaysDataSet = {
            label: 'Lost Production',
            data: lostdays,
            borderWidth: 1,
            backgroundColor: '#dc1414',
            stack: 'manpower',
          };
      var tempLowDataSet = {
            type: 'line',
            backgroundColor: '#4555CC',
            label: 'Temp Low',
            data: lowtemps,
            borderWidth: 1,
            drawActiveElementsOnTop: true,
          };
      var tempHighDataSet = {
            type: 'line',
            label: 'Temp High',
            backgroundColor: '#e79519',
            data: hightemps,
            borderWidth: 1,
            drawActiveElementsOnTop: true,
          };

      var iceDataSet = {
            label: 'Ice',
            data: ice,
            borderWidth: 1,
            backgroundColor: '#d90eb4',
            stack: 'manpower',
          };
      var rainDataSet = {
            label: 'Rain',
            data: rain,
            borderWidth: 1,
            backgroundColor: '#3e8eff',
            stack: 'manpower',
          };
      var snowDataSet = {
            label: 'Snow',
            data: snow,
            borderWidth: 1,
            backgroundColor: '#9a2dff',
            stack: 'manpower',
          };
      var sunDataSet = {
            label: 'Sun',
            data: sun,
            borderWidth: 1,
            backgroundColor: '#c4bd00',
            stack: 'manpower',
          };
      var windDataSet = {
            label: 'Wind',
            data: wind,
            borderWidth: 1,
            backgroundColor: '#0bb0a2',
            stack: 'manpower',
          };
      
      var dataSets = [];
      if (document.querySelector('#cmanpower').checked) { dataSets.push(manpowerDataSet); }
      if (document.querySelector('#clostdays').checked) { dataSets.push(lostdaysDataSet); }
      if (document.querySelector('#ctemp-low').checked) { dataSets.push(tempLowDataSet); }
      if (document.querySelector('#ctemp-high').checked) { dataSets.push(tempHighDataSet); }
      if (document.querySelector('#cice').checked) { dataSets.push(iceDataSet); }
      if (document.querySelector('#crain').checked) { dataSets.push(rainDataSet); }
      if (document.querySelector('#csnow').checked) { dataSets.push(snowDataSet); }
      if (document.querySelector('#csun').checked) { dataSets.push(sunDataSet); }
      if (document.querySelector('#cwind').checked) { dataSets.push(windDataSet); }
       

      this.currentchart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: clabelsformat, //['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
          datasets: dataSets,
        },
        options: {
          scales: {
            y: {
              beginAtZero: true
            },
          },
          plugins: {
            legend: {
                display: true,
                labels: {
                    font: { size: '18px' },
                    padding:20,
                },
            }
        }
        }
      });

      document.querySelector('#generatedat').textContent = moment().format('dddd, MMMM DD, YYYY @hh:mm:ss A');
    },
  }
}   
</script>